import { Component, Input } from '@angular/core';

import { statusProjetadoProjetado } from '../../cliente-analise-mercado-status-projetado';
import { ClienteAnaliseMercadoStatusProjetadoPipe } from '../../pipes';

@Component({
    selector: 'sgt-cliente-analise-mercado-status-projetado-badge-projetado',
    templateUrl: './cliente-analise-mercado-status-projetado-badge-projetado.component.html',
    styleUrls: ['./cliente-analise-mercado-status-projetado-badge-projetado.component.less']
})
export class ClienteAnaliseMercadoStatusProjetadoBadgeProjetadoComponent {
    status = statusProjetadoProjetado;

    /** Title para exibir no badge */
    @Input() title: string = null;

    constructor(private clienteAnaliseMercadoStatusProjetadoPipe: ClienteAnaliseMercadoStatusProjetadoPipe) { }

    /** Retorna o title para exibir no badge */
    getTitle(): string {
        return this.title ? this.title : this.clienteAnaliseMercadoStatusProjetadoPipe.transform(this.status.id);
    }
}
